var map = {
	"./banana_tree/UK/bt_bath/team.json": [
		1087,
		1087
	],
	"./banana_tree/UK/bt_battersea/team.json": [
		3243,
		3243
	],
	"./banana_tree/UK/bt_birmingham_bullring/team.json": [
		6444,
		6444
	],
	"./banana_tree/UK/bt_cardiff/team.json": [
		8635,
		8635
	],
	"./banana_tree/UK/bt_chelmsford/team.json": [
		5137,
		5137
	],
	"./banana_tree/UK/bt_covent_garden/team.json": [
		2129,
		2129
	],
	"./banana_tree/UK/bt_greenwich/team.json": [
		1828,
		1828
	],
	"./banana_tree/UK/bt_haywards_heath/team.json": [
		6116,
		6116
	],
	"./banana_tree/UK/bt_henley/team.json": [
		7773,
		7773
	],
	"./banana_tree/UK/bt_islington/team.json": [
		9535,
		9535
	],
	"./banana_tree/UK/bt_maida_vale/team.json": [
		7895,
		7895
	],
	"./banana_tree/UK/bt_milton_keynes/team.json": [
		1385,
		1385
	],
	"./banana_tree/UK/bt_oxford/team.json": [
		6110,
		6110
	],
	"./banana_tree/UK/bt_portsmouth/team.json": [
		2685,
		2685
	],
	"./banana_tree/UK/bt_salford_quays/team.json": [
		1377,
		1377
	],
	"./banana_tree/UK/bt_soho/team.json": [
		1781,
		1781
	],
	"./banana_tree/UK/bt_stevenage/team.json": [
		9926,
		9926
	],
	"./banana_tree/UK/bt_the_o2/team.json": [
		2463,
		2463
	],
	"./banana_tree/UK/bt_west_hampstead/team.json": [
		3983,
		3983
	],
	"./banana_tree/UK/bt_windsor/team.json": [
		8370,
		8370
	],
	"./breakfast_club/UK/london_bridge/team.json": [
		4305,
		4305
	],
	"./honest_burger/UK/south_ken/team.json": [
		5858,
		5858
	],
	"./kricket/UK/shoreditch/team.json": [
		2239,
		2239
	],
	"./moto/UK/cherwell_valley_burger_king/team.json": [
		1456,
		1456
	],
	"./moto/UK/cherwell_valley_greggs/team.json": [
		688,
		688
	],
	"./moto/UK/chieveley_burger_king/team.json": [
		9804,
		9804
	],
	"./moto/UK/chieveley_greggs/team.json": [
		1604,
		1604
	],
	"./moto/UK/toddington_burger_king/team.json": [
		9586,
		9586
	],
	"./moto/UK/toddington_greggs/team.json": [
		9138,
		9138
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9362;
module.exports = webpackAsyncContext;